import './Page.css';
import WorkshopComponent from "../componetns/menu/workshop/WorkshopComponent";
import CardVeryBig from "../componetns/card/CardVeryBig";
import React from "react";

function Workshop() {
    return (
        <div className="main_work_field">
            <CardVeryBig/>
            <WorkshopComponent/>
        </div>
    );
}

export default Workshop;